import { render } from "./Watch2Sc.vue?vue&type=template&id=58288434&scoped=true"
import script from "./Watch2Sc.vue?vue&type=script&lang=js"
export * from "./Watch2Sc.vue?vue&type=script&lang=js"

import "./Watch2Sc.vue?vue&type=style&index=0&id=58288434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58288434"]])

export default __exports__